// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.10.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#admin-new-user-form {
  width: 720px;
  min-height: 500px;
}

  #admin-new-user-form .card__header .add-user-icon {
      margin-right: 0.5rem;
    }

  #admin-new-user-form .card__header .close-icon {
      cursor: pointer;
    }

  #admin-new-user-form .card__body {
    display: block;
    padding-top: 1rem;
  }

  #admin-new-user-form .account-information {
    display: flex;
    align-items: center;
  }

  #admin-new-user-form .account-information h4 {
      margin-right: 0.5rem;
    }

  #admin-new-user-form .field-section {
    display: flex;
    align-items: center;
  }

  #admin-new-user-form .field-section .form__label {
      width: 33%;
      display: flex;
      flex-direction: column;
    }

  #admin-new-user-form .field-section .form__label span:last-child {
        color: gray;
        font-size: 0.8rem;
      }

  #admin-new-user-form .field-section .form__label {
      margin-right: 0.5rem;
}

  #admin-new-user-form .submission-message-container {
    font-size: 1rem;
    margin-bottom: 1rem;
  }

  #admin-new-user-form .buttons-container {
    display: flex;
    justify-content: space-between;
    grid-gap: 1rem;
    gap: 1rem;
  }
`, "",{"version":3,"sources":["webpack://./src/components/AdminAddNewUserForm.pcss","<no source>"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,iBAAiB;AAiDnB;;EA9CI;MACE,oBAAoB;IACtB;;EACA;MACE,eAAe;IACjB;;EAGF;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,mBAAmB;EAIrB;;EAHE;MACE,oBAAoB;IACtB;;EAGF;IACE,aAAa;IACb,mBAAmB;EAWrB;;EAVE;MACE,UAAU;MACV,aAAa;MACb,sBAAsB;IAMxB;;EALE;QACE,WAAW;QACX,iBAAiB;MACnB;;ECpCN;MDqCM;CCrCN;;EDyCE;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,cAAS;IAAT,SAAS;EACX","sourcesContent":["#admin-new-user-form {\n  width: 720px;\n  min-height: 500px;\n\n  .card__header {\n    .add-user-icon {\n      margin-right: 0.5rem;\n    }\n    .close-icon {\n      cursor: pointer;\n    }\n  }\n\n  .card__body {\n    display: block;\n    padding-top: 1rem;\n  }\n\n  .account-information {\n    display: flex;\n    align-items: center;\n    h4 {\n      margin-right: 0.5rem;\n    }\n  }\n\n  .field-section {\n    display: flex;\n    align-items: center;\n    .form__label {\n      width: 33%;\n      display: flex;\n      flex-direction: column;\n      span:last-child {\n        color: gray;\n        font-size: 0.8rem;\n      }\n      margin-right: 0.5rem;\n    }\n  }\n\n  .submission-message-container {\n    font-size: 1rem;\n    margin-bottom: 1rem;\n  }\n\n  .buttons-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 1rem;\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
